import * as React from "react";
import { mkBaseHooks } from "@discovery/orchestra/lib/base";
import { mkDebounceDispatch } from "@discovery/orchestra/lib/debounce";
import { history as initHistory } from "@discovery/maestro-history/lib/impl/window.history";
import { mkHistory } from "@discovery/orchestra/lib/history";
import { mkInView } from "@discovery/orchestra/lib/intersection";
import { mkGlobalState } from "@discovery/orchestra/lib/global-state";
import { initialState } from "./state";
const _history = initHistory();
const history = () => _history;
export const maestroHistory = history();
const baseHooks = mkBaseHooks(React);
const { useCallback, useContext, useEffect, useRef, useState, useMemo } = mkBaseHooks(React);
const useDebounceDispatch = mkDebounceDispatch({
    useCallback,
    useEffect,
    useRef,
});
export const { useHistory } = mkHistory(baseHooks)(Object.assign({}, history()));
export const { useWhenInView, useInView } = mkInView(baseHooks)({
    observer: IntersectionObserver,
});
const { useGlobalState, useGlobalStateModifier, updateGlobalState } = mkGlobalState({
    useCallback,
    useEffect,
    useState,
})({
    initialState,
});
export { useCallback, useContext, useEffect, useRef, useState, useMemo, useDebounceDispatch, useGlobalState, useGlobalStateModifier, updateGlobalState, };

